import { Button, Form, Input } from 'antd';
import { FC } from 'react';

import InputRemoveIcon from '@/components/icons/InputRemoveIcon';

import InputError from './InputError';

interface VerifyCodeProps {
  t: (key: string) => string;
  accountId: string | undefined;
  sendCodeState: boolean;
  countDown: number;
  isHasPassword: boolean;
  loading: boolean;
  inputErrorMsg?: string;
  onValuesChange?: (values: { code: string }) => void;
  onSendCode: () => void;
  onVerifySuccess: (code: string) => void;
  onClearVerifyInput: () => void;
}

type FieldType = {
  code?: string;
};

export const VerifyCode: FC<VerifyCodeProps> = ({
  t,
  accountId,
  sendCodeState,
  countDown,
  loading,
  inputErrorMsg,
  onValuesChange,
  onSendCode,
  onVerifySuccess,
  onClearVerifyInput,
}) => {
  // 验证码提交
  const handleFinishCode = async (values: { code: string }) => {
    await onVerifySuccess(values.code);
  };

  return (
    <div>
      <div className="mt-8 py-1">
        <p className="h4-style mb-4">{t('merror.login.input.code')}</p>
        <span className="p-style mb-1" style={{ color: '#000' }}>
          {t('merror.forgetPwd.tip.1')}
        </span>
        <span className="p-style ml-1" style={{ color: '#4e4ee9' }}>
          {accountId}
        </span>
        <div className="flex py-1 mt-5 justify-between items-center">
          <p className="body-style mb-1">{t('merror.login.code.title')}</p>

          {sendCodeState ? (
            <p
              className="cursor-pointer button-label-style"
              style={{ color: '#444' }}
            >{`${t('merror.login.code.resend')}(${countDown}s)`}</p>
          ) : (
            <div
              className="cursor-pointer button-label-style"
              style={{ color: '#4e4ee9', opacity: 0.8 }}
              onClick={onSendCode}
            >
              {t('merror.login.code.resend')}
            </div>
          )}
        </div>

        <Form
          initialValues={{ remember: true }}
          onFinish={handleFinishCode}
          autoComplete="off"
          id="code-login-form"
          className="login-form"
          onValuesChange={onValuesChange}
        >
          <Form.Item<FieldType>
            name="code"
            validateStatus={inputErrorMsg ? 'error' : ''}
            noStyle
          >
            <Input
              placeholder={t('merror.login.input.code.placehoder')}
              className="h-[56px]"
              onClear={onClearVerifyInput}
              allowClear={{
                clearIcon: <InputRemoveIcon />,
              }}
            />
          </Form.Item>

          {inputErrorMsg && <InputError message={inputErrorMsg} />}

          <Form.Item>
            <Button
              loading={loading}
              type="primary"
              htmlType="submit"
              className="w-[100%] mt-8 button-style h-[48px]"
              style={{ height: '48px' }}
            >
              <span className="button-label-style ">{t('merror.login.next')}</span>
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
